import { DiffPatcher } from 'jsondiffpatch';
import { diff_match_patch as DiffMatchPatch } from '@dmsnell/diff-match-patch';

const diffPatcher = new DiffPatcher({
    textDiff: {
        minLength: 50,
        diffMatchPatch: DiffMatchPatch,
    },
});

export default diffPatcher;
